import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/',
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Interceptor para manejar errores de autenticación
api.interceptors.response.use(
    (response) => response,
    (error) => {
        // Obtenemos la URL de la solicitud original para no redirigir si el error 401 viene del login
        const requestUrl = error.config ? error.config.url : '';

        // Solo redirigimos si es 401 Y NO es una petición de login
        if (error.response && error.response.status === 401 && !requestUrl.includes('login')) {
            // Si el token es inválido o ha expirado, redirige al login
            localStorage.removeItem('token');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

// Función para registrar un nuevo usuario
export const registerUser = async (userData) => {
    try {
        const response = await api.post('/api/user/register', userData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export default api;
